require('../brokerTransferExternalSteps.scss');
require('./brokerTransferExternalStep1.scss');

const PropTypes = require('prop-types');

// @ vendors
const React = require('react');
const classNames = require('classnames');
// @ helpers
const { formatText, FormattedText } = require('core/i18n').i18n;
// @ components
const StocksContractDropdown = require('components/broker/commons/stocksContractDropdown/stocksContractDropdown');
const { RadioButtonGroup } = require('commonsComponents/radioButtonGroup');
const { InputSafe } = require('commonsComponents/inputSafe');
const { RadioButton } = require('commonsComponents/radioButton');
const OKSelect = require('components/commons/OKSelect/OKSelect');
// @ constants
const {
    FIRST_STEP,
    BROKER_TYPE_BANK_NAME,
    BROKER_TYPE_AGENCIE,
    BROKER_TRASPASS_EXTERNAL_NUMERIC_VALIDATION_REGEX,
    BROKER_STOCKS_CONTRACT_DROPDOWN_ACCOUNT_EXTERNAL_TRANSFER_MODIFIER
 } = require('constants/index');

class BrokerTransferExternalStep1 extends React.Component {
    constructor(props) {
        super(props);

        this.state={
            showAgencie: false,
            selectedType: ''
        };


        this.buildStocksContractDropdownOptions = this.buildStocksContractDropdownOptions.bind(this);
        this.handleAccountToChange = this.handleAccountToChange.bind(this);
        this.conditionalInput = this.conditionalInput.bind(this);
        this.handleAgencieContractInputChange = this.handleAgencieContractInputChange.bind(this);
        this.handleAgencieChange = this.handleAgencieChange.bind(this);
        this.handleRadiosChange = this.handleRadiosChange.bind(this);
        this.handleBankInputChange = this.handleBankInputChange.bind(this);
        this.handleDcInputChange = this.handleDcInputChange.bind(this);
        this.handleOfficeInputChange = this.handleOfficeInputChange.bind(this);
        this.handleContractInputChange = this.handleContractInputChange.bind(this);
    }

    componentWillMount() {
        const { immTransferExternalValues } = this.props;
        const transferType = immTransferExternalValues.getIn(['steps', FIRST_STEP, 'transferType'])
        let type = '';
        if (transferType.get(BROKER_TYPE_BANK_NAME).get('value')) {
            type = transferType.get(BROKER_TYPE_BANK_NAME).get('name');
            this.setState({'showAgencie': false, 'selectedType': type});
        } else if (transferType.get(BROKER_TYPE_AGENCIE).get('value')) {
            type = transferType.get(BROKER_TYPE_AGENCIE).get('name');
            this.setState({'showAgencie': true, 'selectedType': type});
        }
    }

    componentDidMount() {
        this.props.getAgencies();
    }

    buildAgenciesDropdownOptions() {
        const { immTransferExternalValues } = this.props;
        const agencies = immTransferExternalValues.getIn(['steps', FIRST_STEP, 'agencies'])
        const processedAgencies = agencies.map((entry, index) => entry.merge({ value: index, label: entry.get('agencieName') }));
        return processedAgencies.toJS();
    }

    buildSelector({title, label, handler, options, selectedValue, placeholder, errorState, errorMessage}) {
        return (
            <section className="broker-transfer-external-step1__selector">
                <h3 className="broker-transfer-external-step1__selector-title">
                    <FormattedText value={title} />
                </h3>
                <StocksContractDropdown
                    label={label}
                    onStockContractChange={handler}
                    options={options}
                    selectedValue={selectedValue}
                    placeholder={placeholder}
                    errorState={errorState}
                    errorMessage={errorMessage}
                    modifier={BROKER_STOCKS_CONTRACT_DROPDOWN_ACCOUNT_EXTERNAL_TRANSFER_MODIFIER}
                />
            </section>
        );
    }

    buildStocksContractDropdownOptions() {
        const { immTraspassFunds } = this.props;
        const traspassFunds = immTraspassFunds.get('funds');
        const processedTraspassFunds = traspassFunds.map((entry, index) => entry.merge({ value: index }));
        return processedTraspassFunds.toJS();
    }

    conditionalInput(value, inputOnChange, errorState, errorMessage, label, modifier, placeholder, maxLength) {
        const customClass = classNames(modifier);
        return (
            <div className={customClass}>
                <InputSafe
                    type="text"
                    value={value}
                    onChange={inputOnChange}
                    errorState={errorState}
                    errorMessage={errorMessage}
                    label={label}
                    placeholder={placeholder}
                    maxLength={maxLength}
                    autoComplete="off"
                />
            </div>
        );
    }

    handleAccountToChange(accountId) {
        this.props.setAccountTo(accountId);
    }

    handleAgencieChange(option) {
        this.props.setAgencie(option.value);
    }

    handleAgencieContractInputChange(event) {
        const { value } = event.target;
        this.props.setAgencieContract(value.replace(BROKER_TRASPASS_EXTERNAL_NUMERIC_VALIDATION_REGEX, ''));
    }

    handleBankInputChange(event) {
        const { value } = event.target;
        this.props.setContractBank(value.replace(BROKER_TRASPASS_EXTERNAL_NUMERIC_VALIDATION_REGEX, ''));
    }

    handleContractInputChange(event) {
        const { value } = event.target;
        this.props.setContract(value.replace(BROKER_TRASPASS_EXTERNAL_NUMERIC_VALIDATION_REGEX, ''));
    }

    handleDcInputChange(event) {
        const { value } = event.target;
        this.props.setContractDc(value.replace(BROKER_TRASPASS_EXTERNAL_NUMERIC_VALIDATION_REGEX, ''));
    }

    handleOfficeInputChange(event) {
        const { value } = event.target;
        this.props.setContractOffice(value.replace(BROKER_TRASPASS_EXTERNAL_NUMERIC_VALIDATION_REGEX, ''));
    }

    handleRadiosChange(value) {
        const { immTransferExternalValues } = this.props;
        const transferType = immTransferExternalValues.getIn(['steps', FIRST_STEP, 'transferType'])
        let type = '';
        if (value === transferType.get(BROKER_TYPE_BANK_NAME).get('name')) {
            this.props.setTypeBoB(true);
            this.props.setTypeAgencie(false);
            type = transferType.get(BROKER_TYPE_BANK_NAME).get('name');
            this.setState({'showAgencie': false,'selectedType': type});
        } else if (value === transferType.get(BROKER_TYPE_AGENCIE).get('name')) {
            this.props.setTypeBoB(false);
            this.props.setTypeAgencie(true);
            type = transferType.get(BROKER_TYPE_AGENCIE).get('name');
            this.setState({'showAgencie': true,'selectedType': type});
        }
    }

    render() {
        const { immTransferExternalValues } = this.props;
        const contractNumber = immTransferExternalValues.getIn(['steps', FIRST_STEP, 'contractNumber']);
        const transferType = immTransferExternalValues.getIn(['steps', FIRST_STEP, 'transferType'])
        const errors = immTransferExternalValues.getIn(['steps', FIRST_STEP, 'errors']);
        const agencieContractInputErrorMessage = formatText('broker-transferExternalStep1AgencieContractError');
        const placeholder = formatText('broker-stocksBuyStep1SelectPlaceholder');
        const selectOptions = this.buildStocksContractDropdownOptions();
        const accountDropDownError = formatText('broker-transferExternalStep1SelectAccountError');
        const accountToSelector = this.buildSelector({
            title: 'broker-transferValuesStep1SelectAccountTo',
            label: 'broker-transferValuesStep1AccountTo',
            handler: this.handleAccountToChange,
            options: selectOptions,
            selectedValue: immTransferExternalValues.getIn(['steps', FIRST_STEP, 'accountIdTo']),
            placeholder,
            errorState: errors.get('selectedAccount'),
            errorMessage: accountDropDownError
        });

        const agencieContractInput = this.conditionalInput(
            immTransferExternalValues.getIn(['steps', FIRST_STEP, 'agencieContract']),
            this.handleAgencieContractInputChange,
            errors.get('agencieContractInput'),
            agencieContractInputErrorMessage,
            '',
            'broker-transfer-external-step1__text-input-wrapper',
            '0000',
            10
        );

        const getAgenciesDropdown = (
            <OKSelect
                label={formatText('broker-transferExternalStep1LabelAgencias')}
                onChange={this.handleAgencieChange}
                options={this.buildAgenciesDropdownOptions()}
                value={immTransferExternalValues.getIn(['steps', FIRST_STEP, 'agencie'])}
                autosize={false}
                placeholder={formatText('broker-transferExternalStep1SelectAgencias')}
                errorState={errors.get('selectedAgencie')}
                errorMessage={formatText('broker-transferExternalStep1SelectAgenciasError')}
                searchable={false}
            />
        );

        const getAgencieContract = (
            <div className="broker-transfer-external-step1__agencie-box">
                <div>
                    <div className="broker-transfer-external-steps__input-label">{formatText('broker-transferExternalStep1AgencieContractLabel')}</div>
                    <div>{agencieContractInput}</div>
                </div>
                <div className="broker-transfer-external-steps__group-div">{getAgenciesDropdown}</div>
            </div>
        );

        const contractBankInput = this.conditionalInput(
            contractNumber.get('bank'),
            this.handleBankInputChange,
            errors.get('inputBank'),
            '',
            formatText('broker-transferExternalBankLabel'),
            'broker-transfer-external-step1__text-input-bank',
            '0000',
            4);

        const contractOfficeInput = this.conditionalInput(
            contractNumber.get('office'),
            this.handleOfficeInputChange,
            errors.get('inputOffice'),
            '',
            formatText('broker-transferExternalOfficeLabel'),
            'broker-transfer-external-step1__text-input-bank',
            '0000',
            4
        );

        const contractDcInput = this.conditionalInput(
            contractNumber.get('dc'),
            this.handleDcInputChange,
            errors.get('inputDc'),
            '',
            formatText('broker-transferExternalDcLabel'),
            'broker-transfer-external-step1__text-input-bank',
            '00',
            2
        );

        const contractInput = this.conditionalInput(
            contractNumber.get('contract'),
            this.handleContractInputChange,
            errors.get('inputContract'),
            '',
            formatText('broker-transferExternalContractLabel'),
            'broker-transfer-external-step1__text-input-contract',
            '0000000000',
            10
        );

        const getBankInputs = (
            <div>
                <div>
                    <div className="broker-transfer-external-steps__input-label">{formatText('broker-transferExternalStep1BankLabel')}</div>
                    <div >{contractBankInput}{contractOfficeInput}{contractDcInput}{contractInput}</div>
                </div>
            </div>
        );

        return (
            <article className="broker-transfer-external-steps broker-transfer-external-step1">
                <header className="broker-transfer-external-steps__header">
                    <FormattedText value="broker-transferExternalStep1Title" className="broker-transfer-external-steps__title" />

                    <FormattedText value="broker-transferExternalStep1SubTitle" className="broker-transfer-external-steps__subtitle" />
                </header>
                <section className="broker-transfer-values-step__content">

                    <span>
                        <h2 className="broker-transfer-external-step1__agencie-title">
                            <FormattedText value="broker-transferExternalForText" />
                        </h2>
                        <RadioButtonGroup
                            selectedValue={this.state.selectedType}
                            onChange={this.handleRadiosChange}
                            name="externalTransferRadioGroup"
                            idPrefix="externalTransferRadioGroup"
                         >
                            <RadioButton
                                label={formatText('broker-transferExternalBankOrBoxLabel')}
                                value={transferType.get(BROKER_TYPE_BANK_NAME).get('name')}
                                className="broker-transfer-external-step1__radio-button"
                            />
                            <RadioButton
                                label={formatText('broker-transferExternalAgencieLabel')}
                                value={transferType.get(BROKER_TYPE_AGENCIE).get('name')}
                                className="broker-transfer-external-step1__radio-button"
                            />
                        </RadioButtonGroup>
                    </span>
                    <span className="broker-transfer-external-steps__group-div">
                        { this.state.showAgencie ? getAgencieContract : getBankInputs }
                    </span>
                    <span>
                        {accountToSelector}
                    </span>
                </section>
            </article>
        )
    }
}

BrokerTransferExternalStep1.propTypes = {
    immTransferExternalValues: PropTypes.object.isRequired,
    immTraspassFunds: PropTypes.object.isRequired,
    setAccountTo: PropTypes.func.isRequired,
    setAgencieContract: PropTypes.func.isRequired,
    getAgencies: PropTypes.func.isRequired,
    setAgencie: PropTypes.func.isRequired,
    setContract: PropTypes.func.isRequired,
    setContractBank: PropTypes.func.isRequired,
    setContractOffice: PropTypes.func.isRequired,
    setContractDc: PropTypes.func.isRequired,
    setTypeBoB: PropTypes.func.isRequired,
    setTypeAgencie: PropTypes.func.isRequired
}

module.exports = BrokerTransferExternalStep1;